import './App.css';
import Login from './pages/login'
import 'primeicons/primeicons.css';
import Home from './pages/home'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import NavContext from './contexts/NavContext';
import { CustomerProvider } from './contexts/CustomerContext';

const App = () => {
  const [nav, setNav] = useState('');
  const value = { nav, setNav };
  return (
    <NavContext.Provider value={value}>
    <CustomerProvider>
      <Router>
        <div className="App">
        </div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
        </Routes>
      </Router></CustomerProvider>
    </NavContext.Provider>
  );
}

export default App;
